import { Injectable } from '@angular/core';
import { ID } from '@datorama/akita';
import { NgEntityService } from '@datorama/akita-ng-entity-service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SMAlertRule } from '../../model/sm-alertrule';
import { UrlConfig } from '../../model/urlconfig';
import { HttpOptions, UpdateActionType } from '../../service/generic-akita-http.service';
import { WebsocketService } from '../../service/websocket.service';
import { encodeFiwareString } from '../../shared/replacer-util';
import { SmAlertRuleState, SmAlertRuleStore } from '../state/sm-alert-rule.store';
import { AkitaSMAlertRuleHttpService } from './akita-http-sm-alertrule';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class SmAlertRuleService extends NgEntityService<SmAlertRuleState> implements UrlConfig {

  constructor(
    protected store: SmAlertRuleStore,
    private smAlertHttpService: AkitaSMAlertRuleHttpService,
    private webSocketService: WebsocketService,
  ) {
    super(store);

    this.webSocketService.getDataStream('SmAlertRule')
      .pipe(untilDestroyed(this))
      .subscribe((data: SMAlertRule[]) => this.store.upsertMany(data));
  }
  updateEntitiesUrl(newUrl: string): void {
    this.smAlertHttpService.setEntitiesUrl(newUrl);
  }

  getAll() {
    this.smAlertHttpService.getAll().subscribe(sm => this.store.upsertMany(sm));
  }

  getById(id: ID) {
    this.smAlertHttpService.loadById(id).subscribe(sm => this.store.add(sm));
  }

  addSmAlertRule(smAlertRule: SMAlertRule) {
    this.store.add(smAlertRule);
    this.addSmAlertRuleToFiware(smAlertRule);
  }

  updateSmAlertRule(alertRule: SMAlertRule) {
    this.store.update(alertRule.id, alertRule);
    this.addSmAlertRuleToFiware(alertRule);
  }

  private addSmAlertRuleToFiware(alertRule: SMAlertRule) {
    const options: HttpOptions = {
      params: {
        options: 'keyValues'
      }
    };

    const copy = { ...alertRule };
    copy.name = encodeFiwareString(alertRule.name);
    copy.errorMessage = encodeFiwareString(alertRule.errorMessage);
    copy.dateLastModified = new Date().toISOString();

    this.smAlertHttpService.update(copy, UpdateActionType.APPEND, options)
      .subscribe(
        data => console.log('updated alert rule', data),
        err => console.log('error updating alert rule')
      );
  }

  deleteAlert(alertRule: SMAlertRule) {
    this.store.remove(alertRule.id);

    const copy = { ...alertRule };
    copy.name = encodeFiwareString(alertRule.name);
    copy.errorMessage = encodeFiwareString(alertRule.errorMessage);
    copy.dateLastModified = new Date().toISOString();

    copy.deleted = true;
    copy.active = false;

    const options: HttpOptions = {
      params: {
        options: 'keyValues'
      }
    };
    this.smAlertHttpService.update(copy, UpdateActionType.APPEND, options)
      .subscribe(
        data => console.log('updated for delete alertrule', data),
        err => console.log('error deleting alertrule', err)
      );
  }
}
